import { type AdminCouponsListParams, getAdminCouponsListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminCouponsListParams };

export const couponsQuery = ({ search }: QueriesInput) => getAdminCouponsListQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [couponsQuery(input)];
